/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — nc-experience.js
   asset: assets/nc-experience.js
   Aggiornato: 15 luglio 2026 — 18:43 (Europe/Rome)
   Versione: 2.9.2  (esclusione prodotti dalle CTA quiz)

   Modifiche v2.9.2 (15 lug 2026):
   - ESCLUSIONE PRODOTTI: guardia `if (window.SkonQuizExcluded && window.SkonQuizExcluded())
     return;` in testa alle QUATTRO superfici che INVITANO al quiz:
       _renderStrip              (strip contestuale PDP)
       _renderQuizLinkAfterATC   (link "Trova la tua routine" sotto Acquista)
       _showExitSheet            (exit-intent)
       _renderPriceNoteGeneric   (nota "...ti costa meno. Scopri come →" → QUIZ_URL:
                                  va a chi NON ha una routine, è un invito a tutti
                                  gli effetti anche se non lo sembra)
     La lista dei prodotti esclusi e il matcher vivono in skon-handle-map.js v1.2
     (window.SKON_NO_QUIZ_PRODUCTS): unico punto da modificare, nessuna logica
     duplicata qui.
     NON toccate le superfici che mostrano il RISULTATO: _renderPriceNote (chi ha
     una routine, nessun link al quiz), badge protocollo, sticky bar. Non invitano
     a nulla: dicono quanto paghi col tuo codice.
     Se handle-map non carica, le guardie falliscono APERTE (identico a prima).
     Caso d'origine: integratore collagene — campagna Meta dedicata, ma non è mai
     CORE di nessuna delle 28 routine (tip in 16/28).

   Modifiche v2.9.1 (14 lug 2026):
   - STRIP PDP SPENTA di default: aggiunta guardia `if (!window.SKON_NC_STRIP) return;`
     in testa a _renderStrip (declutter PDP, richiesta Matteo — troppa roba cliccabile:
     strip + popup identità sulla stessa pagina). Price-note, badge, exit-intent e il
     popup fs-onboarding NON sono toccati. Per RIACCENDERE la strip: aggiungere
     `window.SKON_NC_STRIP = true;` in skon-quiz-priority.js (accanto agli altri toggle).

   Modifiche v2.9.0 (13 lug 2026):
   - SOPPRESSIONE INVITI QUIZ: le superfici che INVITANO a fare il quiz escono
     subito se esiste già una routine. Guardia `if (_quizResult()) return;` in
     testa a _renderStrip, _renderQuizLinkAfterATC ed _showExitSheet (exit-intent).
     Motivo: con SKON_NC_POSTQUIZ=true un lead post-quiz supera il cancello di
     _runPdp e riceveva comunque il link PDP "Trova la tua routine" e l'exit-sheet
     "Fai il test" — sollecitandolo a rifare una cosa già fatta. Le superfici che
     mostrano il RISULTATO (sticky bar, badge protocollo, riapplicazione codice)
     NON sono toccate. Cancello = la ROUTINE (localStorage), non il cookie: chi ha
     il cookie ma non la routine va ancora invitato (coerente con _runPdp v2.7.0).
     fs-onboarding v2.3.0 gestiva già il proprio invito.

   Modifiche v2.8.0 (12 lug 2026):
   - Exit-intent: inactivityTimer 25s → 30s. Coordinato col popup identità di
     fs-onboarding (portato a 20s): 10s di finestra per rispondere all'identità
     prima che salga l'exit. (Valore già deployato a mano da Matteo; qui
     consolidato nel file.)
   - Copy exit-intent riscritta SENZA percentuale esplicita (decisione Matteo,
     12 lug). Nuovo framing: "vantaggio / extra di benvenuto che si somma alle
     promozioni già attive". Rimosse le variabili pct/pctLabel/result da
     _showExitSheet → il modale non dipende più da _getDiscountPct()/nc-config
     (elimina il rischio di mostrare il fallback 25% quando /nc-config è
     lento/giù). Headline inattività: "Hai dubbi? Con il test spendi ancora meno."
   - Collisione col toast fs-onboarding gestita via CSS in
     skon-fs-onboarding.css (body:has(#skon-nc-exit) #skonFsObToast).
   - Rimosso un "15%" hardcodato PRE-ESISTENTE in _buildStep3RCB (codice morto
     RC): "un EXTRA 15% sui prodotti singoli" → "un EXTRA di benvenuto...".
     Non introdotto da questa modifica; emerso dal verificatore invarianti
     (controllo 9c "nessuna % scritta a mano nel frontend").

   Modifiche v2.7.2 (10 lug 2026):
   - Exit-intent RC: il testo prometteva "il secondo prodotto lo paghi al 50%"
     (SK-RITORNO, DiscountCodeBxgy). Dal 10 lug l'RC riceve un EXTRA 15% sui
     prodotti singoli, come l'NC ma da un master separato. Era l'ultima copia
     della vecchia meccanica rimasta VISIBILE agli utenti.

   Modifiche v2.7.0 (10 lug 2026):
   - _ensureDiscountApplied(): il codice personale viene riapplicato alla
     sessione Shopify una volta per sessione. Senza, dal giorno dopo lo stack
     prezzi non compariva e la nota "con il tuo sconto lo paghi solo X"
     prometteva uno sconto che il carrello NON avrebbe applicato: la nota si
     mostrava esattamente quando lo sconto era inattivo.
   - _runPdp: il cancello guarda la ROUTINE (localStorage), non il cookie del
     quiz. Cookie senza routine (localStorage svuotato, altro dispositivo) =
     visitatore da invitare al quiz, non da lasciare a mani vuote.
   - Chi ha un codice personale NON riceve la nota: parla lo stack prezzi, che
     interroga Shopify. Se il codice e' scaduto, non compare nulla e nulla
     viene promesso.
   - Dopo l'applicazione viene emesso `discount:update`: senza, lo stack (che
     gira su DOMContentLoaded, PRIMA di nc-experience) avrebbe letto un
     carrello ancora privo di codice, e alla prima pagina di ogni sessione il
     lead avrebbe visto il prezzo pieno.

   Modifiche v2.6.0 (10 luglio 2026 — 08:48) — deploy ATOMICO con skon-identity v2.2.0,
   skon-quiz.js v3.6.0, skon-fs-test.js v1.6.0, skon-quiz-priority v2.2:
   - _fallbackClassify: RIMOSSA la regola "quiz completato -> RC" (era la
     seconda di tre copie: skon-identity, qui, skon-fs-test). Sostituita dal
     cookie `skon_customer`, scritto solo dopo verifica ordini Shopify.
   - _checkCustomer / _resolveIsCustomer: delegano a SkonID.markCustomer()
     invece di scrivere skon_rc_verified a mano.
   - _runPdp: nuovo cancello `SKON_NC_POSTQUIZ`. Con il fix, un lead post-quiz
     e' NC e arriverebbe a _renderPriceNote() — codice mai eseguito in
     produzione. Il flag lo tiene spento finche' non lo si guarda in faccia.

   Modifiche v2.5.0 (09 luglio 2026 — 23:57):
   - FIX arrotondamento in _formatPrice(): si scontava il prezzo e si
     arrotondava il risultato. Shopify tronca lo SCONTO e lo sottrae.
     12,02 € al 30% → 8,42 €, non 8,41 €. Nuovo _discountedCents().
   - La nota "con il tuo sconto lo paghi solo X" NON viene più iniettata se
     skon-pdp-live-price.js ha già disegnato lo stack sconti (#skonLivePriceStack).
     Era il terzo racconto dello stesso prezzo, e il meno informato: legge il
     DOM — che lo stack nasconde — e ignora sia la promo sia le allocazioni
     reali del motore sconti Shopify.

   Modifiche v2.4.0 (deploy ATOMICO con Worker v2.18.0, skon-quiz.js v3.5.0,
   email-content v2.16.0, skon-quiz-priority v2.1):
   - ADD: _loadMasterPct() -> GET /nc-config. La percentuale mostrata nella
     strip PDP e nell'exit-intent e' ora quella REALE del discount-master
     Shopify. Cambiarla su Admin allinea da solo tutta la UX pre-quiz alla
     percentuale che il quiz consegnera' davvero. Chiamata una volta in init(),
     prima di qualunque render che contenga la percentuale.
   - FIX: _getDiscountPct() ignorava SKON_AB_CONFIG.enabled === false. Il
     gruppo veniva sorteggiato comunque, quindi il congelamento dell'A/B non
     aveva alcun effetto sui prezzi mostrati nel PDP.
   - FIX: _getDiscountPct() PIANTAVA il cookie skon_quiz_group su visitatori
     che non avevano mai fatto il quiz. Quel cookie veniva poi rispettato da
     skon-quiz.js, scavalcando enabled:false. Ora il cookie si legge soltanto.
   - Priorita' delle fonti: quiz gia' fatto (pct del codice personale) >
     master > config A/B congelata. Un codice creato al 30% resta al 30%
     anche se il master scende: non gli si mostra una percentuale piu' bassa.

   INVARIATO: contratto skon_quiz_result (chiavi pct/code/group NON rinominate),
   Caso B RC (data.discountAssigned), _checkCustomer, tutto il resto.

   New Customer Experience — sistema di personalizzazione per NC/RC

   CHANGELOG 2.3.0 (9 giu 2026):
   - ADD (funzionale): _renderQuizLinkAfterATC() — inietta link "Indeciso?
     Trova la tua routine" come sibling DOPO <product-form-component> sulla
     PDP, NC-only. Pattern injection identico a _injectAfterPrice (selettori
     multipli con fallback + MutationObserver 5s). Apre /pages/diagnosi-pelle
     con QUIZ_URL. Storage chiave 'skon_pdp_quiz_link_closed' per chiusura
     persistente nella sessione. Implementa item 1c Fase 1 UX pre-launch.
   - MODIFY (funzionale): _showExitSheet — copy rafforzate con discount
     esplicito (pctLabel già calcolato a riga ~911 ora protagonista delle
     headline). Variabilita' A/B sconto automatica via _getDiscountPct():
     gruppo A vede -25%, gruppo B vede -30%. Edge case RC: _showExitSheet
     viene chiamato solo se _classify()!=='RC' (riga _runPdp, v2.6.0), nessun
     rischio di mostrare sconto NC a un RC.
     • Trigger 'scrollback' (desktop mouse-out): headline ora "Aspetta —
       il tuo -X% è qui." / sub "{nome}, in 2 minuti..." / CTA primary
       "Fai il test e ottieni il -X% →"
     • Trigger 'inactivity' (mobile 25s no-touch): headline ora "Hai dubbi?
       Risparmi -X%." / sub e CTA aggiornati coerentemente.
   - STYLE: link PDP usa stile inline temporaneo (font-family Jost, color
     #1f5842, text-decoration underline) — da spostare in nc-experience.css
     in un giro di refactor CSS dedicato. Non urgente, non bloccante.
   - INVARIATO: tutto il resto (strip, price note, sticky bar, classify,
     micro-question sospesa, observer, storage map).
   - Deploy STANDALONE: nessuna dipendenza con altri file. Theme Liquid
     non toccato — pattern injection JS coerente col resto del NC Experience.

   CHANGELOG 2.2.0 (28 mag 2026):
   - WORKER_URL migrato dal vecchio Worker Klaviyo (skon-quiz-check) al
     Worker Magnews (skon-quiz-check-magnews). Schema risposta aggiornato.
   - Caso B/C della micro-question RC: il discriminante non e' piu'
     data.quizIsRepeat (campo del vecchio Worker) ma data.rcDiscountUsed
     (Worker Magnews v2.7.0: verifica sugli ordini Shopify se il codice
     assegnato e' gia' stato usato). Semantica invariata: B = codice non
     ancora usato (lo applichiamo), C = gia' usato (ringraziamo).
   - Codice sconto RC ora DINAMICO: letto da data.discountAssigned
     (campo QUIZ_DISCOUNT_ASSIGNED su Magnews) invece dell'hardcoded
     'SK-RITORNO'. Il codice mostrato e applicato e' sempre quello
     comunicato al visitatore il giorno del quiz. Fallback prudente:
     se discountAssigned manca, il Caso B non applica nulla.
   - 2.1.0 (24 mag): _classify delega a SkonID, micro-question sospesa.

   OTTIMIZZAZIONI WEB VITALS:
   - Eseguito dopo window 'load' (non DOMContentLoaded)
   - Strip iniettata in anchor pre-riservato nel DOM → CLS = 0
   - CSS caricato non-render-blocking (preload + onload swap)
   - Tutti i listener scroll/touch con { passive: true }
   - Scroll handler con debounce 150ms
   - Badge collection via IntersectionObserver (lazy)
   - Zero chiamate di rete aggiuntive (salvo Worker post-email RC)

   STORAGE:
   - sessionStorage 'skon_visitor_type'  = "NC"|"RC"|"unknown"
   - sessionStorage 'skon_nc_product'    = ID catalogo prodotto campagna
   - sessionStorage 'skon_nc_declared'   = "new"|"returning"
   - sessionStorage 'skon_nc_debug'      = "1"
   - sessionStorage 'skon_strip_closed'  = "1"
   - sessionStorage 'skon_microquestion' = "1"
   - sessionStorage 'skon_exit_shown'    = "1"
   - sessionStorage 'skon_added_to_cart' = "1"
   - sessionStorage 'skon_rc_email'      = email RC confermata
   - sessionStorage 'skon_rc_name'       = nome RC confermato
   - sessionStorage 'skon_pdp_quiz_link_closed' = "1" (v2.3.0)
   - localStorage   'skon_quiz_result'   = profilo post-quiz
══════════════════════════════════════════════════════════════════════ */

(function () {
'use strict';

if (!window.SKON_NC_EXPERIENCE) return;

const QUIZ_URL    = '/pages/diagnosi-pelle';
const WORKER_URL  = 'https://skon-quiz-check-magnews.admins-e7e.workers.dev/check-customer';
// v2.4.0 — percentuale del discount-master, letta a runtime. Cambiare la % su
// Shopify Admin allinea da solo tutto cio' che il visitatore vede (strip PDP,
// exit-intent) alla percentuale che il quiz gli consegnera' davvero.
// Risposta cachata sul bordo Cloudflare (s-maxage=300): costo ~zero.
const NC_CONFIG_URL = 'https://skon-quiz-check-magnews.admins-e7e.workers.dev/nc-config';
let _masterPct = null;   // null = non ancora noto / non disponibile

async function _loadMasterPct() {
  if (_masterPct !== null) return _masterPct;
  try {
    const res = await fetch(NC_CONFIG_URL, { signal: AbortSignal.timeout(3000) });
    if (!res.ok) return null;
    const data = await res.json();
    if (data && typeof data.pct === 'number' && data.pct > 0) {
      _masterPct = data.pct;
      return _masterPct;
    }
  } catch (e) { /* offline / worker giu': si resta su null */ }
  return null;
}
const DEBUG_PARAM = 'skon_debug';
const NC_AUDIENCE_PARAM = 'audience';

/* ── Copy per prodotto ───────────────────────────────────────────────── */
const NC_STRIP_COPY = {
  forever_young_cream: {
    text: '<strong>Prima volta su Skön?</strong> Forever Young è il punto di partenza della routine pro-age — peptidi e Rosa Cinese che lavorano sulla struttura della pelle, non sull\'apparenza.',
    cta:  'Scopri il protocollo per te',
  },
  booster_collagene: {
    text: '<strong>Prima volta su Skön?</strong> Il Collagen Elixir agisce dall\'interno stimolando la produzione naturale di collagene — più efficace se abbinato a una routine topica dedicata.',
    cta:  'Scopri il protocollo per te',
  },
  ak_glow: {
    text: '<strong>Nuova su Skön?</strong> Abrakadabra non è solo un fondotinta — è protezione SPF30, idratazione e uniformità in un gesto solo. Trova la tua tonalità e il protocollo giusto.',
    cta:  'Scopri il protocollo per te',
  },
  ak_matt: {
    text: '<strong>Nuova su Skön?</strong> Abrakadabra non è solo un fondotinta — è protezione SPF30, idratazione e uniformità in un gesto solo. Trova la tua tonalità e il protocollo giusto.',
    cta:  'Scopri il protocollo per te',
  },
  _generic: {
    text: 'Prima volta su Skön? I nostri prodotti sono formulati per lavorare in sinergia. Fai il test gratuito e scopri la routine pensata per la tua pelle.',
    cta:  'Scopri il protocollo per te',
  },
  _generic_navigation: {
    text: '<strong>Ogni pelle ha la sua storia.</strong> Scopri la tua routine in 2 minuti — c\'è qualcosa per te alla fine!🎁',
    cta:  'Inizia il test',
  },
};

/* ── Mappatura ID catalogo → frammento handle Shopify ───────────────── */
const HERO_HANDLE_MAP = window.SKON_HANDLE_MAP || {};

/* ── Utilities ───────────────────────────────────────────────────────── */
function _getParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}
function _getCookie(name) {
  const m = document.cookie.match('(?:^|;)\\s*' + name + '=([^;]*)');
  return m ? decodeURIComponent(m[1]) : null;
}
function _ss(key, val) {
  try {
    if (val === undefined) return sessionStorage.getItem(key);
    sessionStorage.setItem(key, val);
  } catch(e) { return null; }
}
function _ls(key) {
  try { return localStorage.getItem(key); } catch(e) { return null; }
}
function _quizResult() {
  try {
    const raw = _ls('skon_quiz_result');
    return raw ? JSON.parse(raw) : null;
  } catch(e) { return null; }
}
/* v2.5.0 — Shopify calcola lo SCONTO e lo tronca ai centesimi, poi lo sottrae:
   12,02 € al 30% → sconto 3,606 → 3,60 → prezzo 8,42 €. Qui si scontava il
   prezzo e si arrotondava il risultato → 8,41 €. Un centesimo per riga.
   Verificato contro il carrello reale (9 lug 2026): 15,60→4,68 · 18,20→5,46 ·
   12,02→3,60. Stessa formula in skon-quiz.js v3.5.2, skon-protocol-widget.js
   v1.2.0 e skon-pdp-live-price.js v1.1.x. */
function _discountedCents(cents, pct) {
  return cents - Math.floor(cents * pct);
}
function _formatPrice(cents, pct) {
  return (_discountedCents(cents, pct) / 100).toFixed(2).replace('.', ',') + '\u00a0€';
}
function _getPdpPriceCents() {
  /* v2.7.0 — Ancorato alla buy-box: `price.liquid` è renderizzato anche dalle
     product card, quindi su un PDP con correlati esistono più <product-price>.
     Stesso ragionamento di skon-pdp-live-price.js v1.1.4. */
  const selectors = [
    '.product-information product-price .price',
    'product-price .price',
    'product-price [ref="priceContainer"] span',
    '[data-product-price]',
    '.price__current',
    '.product__price .money',
    '.price-item--regular',
    '.product-single__price',
  ];
  for (const sel of selectors) {
    const el = document.querySelector(sel);
    if (!el) continue;
    const text = el.textContent.replace(/[^\d,.]/g, '').replace(',', '.');
    const val  = parseFloat(text);
    if (!isNaN(val) && val > 0) return Math.round(val * 100);
  }
  return null;
}
function _userName() {
  const r = _quizResult();
  return (r && r.name) ? r.name : null;
}
function _greet(text, name) {
  if (!name) return text;
  return name + ', ' + text.charAt(0).toLowerCase() + text.slice(1);
}
function _debounce(fn, ms) {
  let t;
  return function() { clearTimeout(t); t = setTimeout(fn, ms); };
}
// Sanitizza una stringa per inserimento sicuro in innerHTML.
// Usato per il codice sconto dinamico (data.discountAssigned) mostrato nel Caso B.
function _escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
function _isOfficeHours() {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Rome',
    weekday: 'long',
    hour: 'numeric',
    hour12: false,
  }).formatToParts(new Date());
  const day  = parts.find(p => p.type === 'weekday').value;
  const hour = parseInt(parts.find(p => p.type === 'hour').value, 10);
  return ['Monday','Tuesday','Wednesday','Thursday','Friday'].includes(day)
    && hour >= 9 && hour < 17;
}
function _supportHref() {
  return _isOfficeHours()
    ? 'https://api.whatsapp.com/send?phone=15558978394&text=Ciao%2C%20ho%20bisogno%20di%20assistenza%2C%20potete%20aiutarmi%3F'
    : 'https://skoncosmetics.com/pages/contact';
}

/* ── Debug mode ──────────────────────────────────────────────────────── */
function _isDebugAllowed() {
  if (!window.SKON_NC_DEBUG) return true;
  if (_getParam(DEBUG_PARAM) === '1') { _ss('skon_nc_debug', '1'); return true; }
  return _ss('skon_nc_debug') === '1';
}

/* ── Riapplicazione del codice personale (v2.7.0) ─────────────────────────
   Il codice del quiz viene applicato alla sessione Shopify SOLO al submit
   (skon-quiz.js). In una sessione successiva — il giorno dopo, da un link
   dell'email, da un'altra scheda — nessuno lo riapplica: `/cart.js` non ha
   codici, la sonda di skon-pdp-live-price non trova allocazioni, lo stack
   non compare.

   Conseguenza prima del fix: compariva invece la nota "con il tuo sconto lo
   paghi solo X", che prometteva uno sconto che il carrello NON avrebbe
   applicato. La nota si mostrava ESATTAMENTE quando lo sconto non era attivo.

   Qui lo riapplichiamo, una volta per sessione. Da lì in poi parla lo stack,
   che chiede a Shopify quanto allocherebbe davvero: se il codice è scaduto o
   esaurito, non compare nulla — e nulla viene promesso. */
function _ensureDiscountApplied(code) {
  if (!code) return;
  const key = 'skon_discount_applied';
  try { if (_ss(key) === code) return; } catch(e) {}
  try {
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'include' })
      .then(function() {
        try { _ss(key, code); } catch(e) {}
        /* Race, altrimenti invisibile: skon-pdp-live-price.js gira su
           DOMContentLoaded, nc-experience su window.load — cioè DOPO. Alla
           prima pagina di una sessione nuova lo stack legge /cart.js prima che
           il codice sia applicato: nessuna allocazione, nessuno stack, prezzo
           pieno. Serve svegliarlo.

           v2.7.1 — Evento PROPRIO, non `discount:update`. Quest'ultimo è
           ascoltato ANCHE dal tema (`cart-items-component`), che si aspetta un
           `detail` di forma precisa e con `detail: null` lancia
           "Cannot read properties of null (reading 'data')" a ogni PDP.
           Non indoviniamo la forma del detail altrui: emettiamo un evento
           nostro, ascoltato da skon-pdp-live-price.js e product-sticky-cart. */
        try {
          document.dispatchEvent(new CustomEvent('skon:discount-applied', {
            bubbles: true,
            detail: { code: code },
          }));
        } catch(e) {}
      })
      .catch(function() {});
    sessionStorage.setItem('skon_discount', code);
  } catch(e) {}
}

/* ── Classificazione visitatore ──────────────────────────────────────────
   DELEGA a window.SkonID (asset skon-identity.js) — fonte di verità unica.
   La cascata a 5 livelli che stava qui è stata estratta in SkonID per
   eliminare la duplicazione con skon-fs-test.js (SkonFS.id.getVisitorType).
   Il blocco _fallbackClassify resta SOLO come rete di sicurezza nel caso
   skon-identity.js non sia caricato su questa pagina (non dovrebbe mai
   succedere: è caricato da theme.liquid prima di nc-experience.js).
──────────────────────────────────────────────────────────────────────── */
function _classify() {
  if (window.SkonID && typeof window.SkonID.getVisitorType === 'function') {
    return window.SkonID.getVisitorType();
  }
  return _fallbackClassify();
}

function _fallbackClassify() {
  // Livello 1 — RC verificato: dichiarazione + conferma Worker (certezza granitica)
  if (_ss('skon_rc_verified') === '1') { _ss('skon_visitor_type', 'RC'); return 'RC'; }

  // Livello 2 — RC da sessione autenticata Shopify o quiz completato
  if (_getCookie('_shopify_customer_token')) { _ss('skon_visitor_type', 'RC'); return 'RC'; }
  /* v2.6.0 — RIMOSSA la regola "quiz completato → RC": un lead che ha compilato
     il quiz non ha comprato. Al suo posto il cookie `skon_customer`, scritto da
     SkonID.markCustomer() solo dopo verifica sugli ordini Shopify. Questa
     cascata è una RETE DI SICUREZZA: se diverge da skon-identity.js torna il
     bug del 9 lug (stessa regola in tre file, corretta in uno solo). */
  if (_getCookie('skon_customer') === '1') { _ss('skon_visitor_type', 'RC'); return 'RC'; }

  // Livello 3 — Parametro URL da Meta (può sbagliare — non sovrascrive livelli 1-2)
  const urlAudience = _getParam(NC_AUDIENCE_PARAM);
  if (urlAudience === 'new') {
    _ss('skon_nc_audience_raw', 'new');
    _ss('skon_visitor_type',    'NC');
    return 'NC';
  }
  if (urlAudience === 'exi') {
    _ss('skon_nc_audience_raw', 'exi');
    _ss('skon_visitor_type',    'RC');
    return 'RC';
  }

  // Livello 4 — Dichiarazione esplicita dalla micro-domanda
  const declared = _ss('skon_nc_declared');
  if (declared === 'returning') { _ss('skon_visitor_type', 'RC'); return 'RC'; }
  if (declared === 'new')       { _ss('skon_visitor_type', 'NC'); return 'NC'; }

  // Livello 5 — Memoria di sessione
  const existing = _ss('skon_visitor_type');
  if (existing === 'NC' || existing === 'RC') return existing;

  return 'unknown';
}

function _getProductId() {
  // Deriva l'ID catalogo dall'handle corrente tramite HERO_HANDLE_MAP invertita
  const handle = _currentProductHandle();
  if (handle) {
    for (const id in HERO_HANDLE_MAP) {
      if (handle.includes(HERO_HANDLE_MAP[id])) {
        _ss('skon_nc_product', id);
        return id;
      }
    }
  }
  // Fallback: sessionStorage per navigazione intra-sessione
  return _ss('skon_nc_product') || null;
}

/* ── Calcolo sconto ──────────────────────────────────────────────────── */
/* v2.4.0 — Ordine delle fonti, dalla piu' specifica alla piu' generica:
   1. result.pct — chi ha gia' fatto il quiz ha un codice PERSONALE con la sua
      percentuale reale. Non va sovrascritta dal master: un codice creato al
      30% vale 30% anche se domani il master scende al 15%.
   2. _masterPct — la percentuale che il quiz consegnera' a chi non l'ha ancora
      fatto. E' la promessa esposta da strip ed exit-intent.
   3. A/B config — solo se il Worker non risponde.

   DUE BUG CORRETTI QUI (v2.3.0):
   - `enabled: false` era ignorato: il gruppo veniva sorteggiato comunque.
   - la funzione PIANTAVA il cookie skon_quiz_group. Un visitatore che non
     aveva mai fatto il quiz si ritrovava assegnato a un gruppo, e quel cookie
     veniva poi rispettato da skon-quiz.js, scavalcando il congelamento.
     Qui il cookie ora si LEGGE soltanto, mai si scrive. */
function _getDiscountPct() {
  const result = _quizResult();
  if (result && result.pct) return result.pct;
  if (_masterPct !== null) return _masterPct;

  const cfg = window.SKON_AB_CONFIG || {};
  let group;
  if (cfg.enabled === false) {
    group = (cfg.forceGroup === 'B') ? 'B' : 'A';
  } else {
    const ck = _getCookie('skon_quiz_group');
    group = (ck === 'A' || ck === 'B') ? ck : 'A';
  }
  const gCfg = (group === 'A' ? cfg.groupA : cfg.groupB) || {};
  return gCfg.pct || 0.25;
}

/* ── Chiamata Worker ─────────────────────────────────────────────────── */
async function _checkCustomer(email) {
  try {
    const res = await fetch(WORKER_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ email }),
      signal:  AbortSignal.timeout(5000),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch(e) { return null; }
}

/* ══════════════════════════════════════════════════════════════════════
   COMPONENTI UI
══════════════════════════════════════════════════════════════════════ */

/* ── Strip contestuale PDP ───────────────────────────────────────────── */
function _renderStrip(productId) {
  if (!window.SKON_NC_STRIP) return;  // v2.9.1 — strip PDP SPENTA di default (declutter PDP); riaccendi con window.SKON_NC_STRIP=true in skon-quiz-priority.js
  if (window.SkonQuizExcluded && window.SkonQuizExcluded()) return;  // v2.9.2 — PDP esclusa dalle CTA quiz (SKON_NO_QUIZ_PRODUCTS in skon-handle-map.js)
  if (_quizResult()) return;  // v2.9.0 — la strip INVITA al quiz: mai a chi ha già una routine
  if (_ss('skon_strip_closed') === '1') return;
  const anchor = document.getElementById('skon-nc-strip-anchor');
  if (!anchor || anchor.dataset.rendered === '1') return;

  const currentHandle     = _currentProductHandle();
  const campaignProductId = _getProductId();
  const isHeroPdp = campaignProductId
    && NC_STRIP_COPY[campaignProductId]
    && currentHandle
    && HERO_HANDLE_MAP[campaignProductId]
    && currentHandle.includes(HERO_HANDLE_MAP[campaignProductId]);

  const copy = isHeroPdp
    ? NC_STRIP_COPY[campaignProductId]
    : NC_STRIP_COPY._generic_navigation;

  const name = _userName();
  const text = name ? _greet(copy.text, name) : copy.text;

  anchor.innerHTML =
    '<div class="skon-nc-strip">'
    + '<div class="skon-nc-strip-inner">'
    + '<p class="skon-nc-strip-text">' + text + '</p>'
    + '<a href="' + QUIZ_URL + '" class="skon-nc-strip-cta">'
    + copy.cta
    + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none"'
    + ' stroke="currentColor" stroke-width="2.5" stroke-linecap="round">'
    + '<path d="M5 12h14M12 5l7 7-7 7"/></svg>'
    + '</a>'
    + '<button class="skon-nc-strip-close" onclick="window._skonCloseStrip()"'
    + ' aria-label="Chiudi">'
    + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none"'
    + ' stroke="currentColor" stroke-width="2.5" stroke-linecap="round">'
    + '<line x1="18" y1="6" x2="6" y2="18"/>'
    + '<line x1="6" y1="6" x2="18" y2="18"/></svg>'
    + '</button>'
    + '</div>'
    + '</div>';

  anchor.dataset.rendered = '1';
}

window._skonCloseStrip = function() {
  const anchor = document.getElementById('skon-nc-strip-anchor');
  if (anchor) {
    anchor.style.transition = 'max-height .2s ease, opacity .2s ease';
    anchor.style.maxHeight  = '0';
    anchor.style.opacity    = '0';
    anchor.style.overflow   = 'hidden';
    setTimeout(function() { anchor.innerHTML = ''; }, 220);
  }
  _ss('skon_strip_closed', '1');
};

/* ── Nota prezzo PDP (quiz completato, prodotto in protocollo) ────────── */
function _renderPriceNote(productHandle) {
  const result = _quizResult();
  if (!result || !result.protocol) return;

const isInProtocol = result.protocol.some(function(id) {
  const fragment = (window.SKON_HANDLE_MAP || {})[id];
  return fragment && productHandle && productHandle.includes(fragment);
});
  if (!isInProtocol) return;
  if (document.querySelector('.skon-nc-price-note')) return;

  /* v2.5.0 — Se skon-pdp-live-price.js ha disegnato lo stack sconti, questa
     nota sarebbe il TERZO racconto dello stesso prezzo sulla stessa pagina, e
     per giunta il meno informato: legge il DOM (che lo stack ha nascosto) e
     non conosce né la promo né ciò che Shopify alloca davvero.
     Lo stack è autoritativo — interroga il motore sconti. Qui ci si fa da parte. */
  if (document.getElementById('skonLivePriceStack')) return;

  const pct      = result.pct || _getDiscountPct();
  const cents    = _getPdpPriceCents();
  if (!cents) return;

  const priceStr = _formatPrice(cents, pct);
  const pctLabel = Math.round(pct * 100) + '%';
  const name     = _userName();
  const noteText = name
    ? name + ', con il tuo sconto lo paghi solo <strong>' + priceStr + '</strong>'
    : 'Con il tuo sconto lo paghi solo <strong>' + priceStr + '</strong>';

  const note = document.createElement('div');
  note.className = 'skon-nc-price-note skon-nc-price-note--quiz-done';
  note.innerHTML =
    '<span class="skon-nc-price-note-badge">-' + pctLabel + '</span>'
    + '<span class="skon-nc-price-note-text">' + noteText + '</span>';

  _injectAfterPrice(note);
}

/* ── Nota prezzo PDP (quiz non ancora fatto) ─────────────────────────── */
function _renderPriceNoteGeneric() {
  if (window.SkonQuizExcluded && window.SkonQuizExcluded()) return;  // v2.9.2 — PDP esclusa dalle CTA quiz: questa nota contiene "Scopri come →" verso QUIZ_URL
  if (document.querySelector('.skon-nc-price-note')) return;

  const name = _userName();
  const text = name
    ? name + ', se è il prodotto giusto per la tua pelle, ti costa meno.'
    : 'Se è il prodotto giusto per la tua pelle, ti costa meno.';

  const note = document.createElement('div');
  note.className = 'skon-nc-price-note skon-nc-price-note--generic';
  note.innerHTML =
    '<span class="skon-nc-price-note-text">' + text + '</span>'
    + '<a href="' + QUIZ_URL + '" class="skon-nc-price-note-link">Scopri come →</a>';

  _injectAfterPrice(note);
}

function _injectAfterPrice(el) {
  const selectors = [
    'product-price',
    '[data-product-price]',
    '.price__current',
    '.product__price .money',
    '.price-item--regular',
    '.product-single__price',
  ];

  function _tryInject() {
    for (const sel of selectors) {
      const priceEl = document.querySelector(sel);
      if (priceEl && priceEl.parentNode) {
        priceEl.parentNode.insertBefore(el, priceEl.nextSibling);
        return true;
      }
    }
    const title = document.querySelector(
      '.product__title, h1.product-single__title, h1[class*="product"]'
    );
    if (title && title.parentNode) {
      title.parentNode.insertBefore(el, title.nextSibling);
      return true;
    }
    return false;
  }

  if (_tryInject()) return;

  const observer = new MutationObserver(function() {
    if (_tryInject()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() { observer.disconnect(); }, 5000);
}

/* ══════════════════════════════════════════════════════════════════════
   PDP — Link "Indeciso? Trova la tua routine" sotto il bottone Acquista (v2.3.0)
   ────────────────────────────────────────────────────────────────────────
   Item 1c della Fase 1 UX pre-launch quiz. NC-only. Pattern injection JS
   coerente con _injectAfterPrice — selettori multipli con fallback +
   MutationObserver 5s per timing su web component <product-form-component>.

   THEME: Shopify Horizon (2024+). Il bottone è dentro <add-to-cart-component>
   con ref="addToCartButton", wrappato da <product-form-component>. Inseriamo
   come SIBLING dopo <product-form-component> per non interferire con il
   submit del form né con l'acceleratedCheckoutButtonContainer (Shop Pay /
   PayPal Express). Stile inline temporaneo — da spostare in nc-experience.css
   in un giro CSS dedicato (annotato in changelog header).

   CHIUSURA: chiave sessionStorage 'skon_pdp_quiz_link_closed' = '1'.
   La X di chiusura dello strip (skon_strip_closed) NON chiude anche questo
   link — sono due UX indipendenti.
══════════════════════════════════════════════════════════════════════ */

function _renderQuizLinkAfterATC() {
  if (window.SkonQuizExcluded && window.SkonQuizExcluded()) return;  // v2.9.2 — PDP esclusa dalle CTA quiz (SKON_NO_QUIZ_PRODUCTS in skon-handle-map.js)
  if (_quizResult()) return;  // v2.9.0 — link "Trova la tua routine": mai a chi ne ha già una
  if (_ss('skon_pdp_quiz_link_closed') === '1') return;
  if (document.querySelector('.skon-nc-pdp-quiz-link')) return;

  // ── Selettori CSS in ordine di preferenza (più specifici prima) ─────
  const selectors = [
    'product-form-component',
    '[data-product-form-component]',
    'add-to-cart-component',
    '.product-form',
  ];

  function _buildLinkEl() {
    const wrap = document.createElement('div');
    wrap.className = 'skon-nc-pdp-quiz-link';
    wrap.setAttribute('role', 'complementary');
    wrap.setAttribute('aria-label', 'Test diagnostico Skön');
    // Stile inline temporaneo — vedi changelog header v2.3.0
    wrap.style.cssText =
      'margin: 14px 0 6px;'
      + 'text-align: center;'
      + 'font-family: \'Jost\', Arial, sans-serif;'
      + 'font-size: 13px;'
      + 'line-height: 1.4;'
      + 'color: rgba(31, 88, 66, 0.85);'
      + 'letter-spacing: 0.2px;';
    wrap.innerHTML =
      '<a href="' + QUIZ_URL + '" class="skon-nc-pdp-quiz-link-a"'
      + ' style="color: #1f5842; text-decoration: underline;'
      + ' text-underline-offset: 3px; font-weight: 500;">'
      + 'Indeciso? Trova la tua routine →'
      + '</a>'
      + '<button type="button" class="skon-nc-pdp-quiz-link-close"'
      + ' onclick="window._skonClosePdpQuizLink()" aria-label="Chiudi"'
      + ' style="background: none; border: 0; padding: 0 0 0 10px;'
      + ' cursor: pointer; color: rgba(31, 88, 66, 0.4); font-size: 12px;'
      + ' line-height: 1; vertical-align: middle;">×</button>';
    return wrap;
  }

  function _tryInject() {
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el && el.parentNode) {
        // Inserisci come sibling DOPO il form/ATC container
        el.parentNode.insertBefore(_buildLinkEl(), el.nextSibling);
        return true;
      }
    }
    return false;
  }

  if (_tryInject()) return;

  const observer = new MutationObserver(function() {
    if (_tryInject()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() { observer.disconnect(); }, 5000);
}

window._skonClosePdpQuizLink = function() {
  const el = document.querySelector('.skon-nc-pdp-quiz-link');
  if (el) {
    el.style.transition = 'opacity .2s ease, max-height .2s ease';
    el.style.maxHeight  = '0';
    el.style.opacity    = '0';
    el.style.overflow   = 'hidden';
    setTimeout(function() { if (el.parentNode) el.parentNode.removeChild(el); }, 220);
  }
  _ss('skon_pdp_quiz_link_closed', '1');
};

/* ══════════════════════════════════════════════════════════════════════
   MICRO-DOMANDA — sistema a step con flusso NC/RC
══════════════════════════════════════════════════════════════════════ */

function _renderMicroQuestion() {
  if (_ss('skon_microquestion') === '1') return;
  if (document.getElementById('skon-nc-micro')) return;

  const micro = document.createElement('div');
  micro.id        = 'skon-nc-micro';
  micro.className = 'skon-nc-micro';
  _buildStep1(micro);

  document.body.appendChild(micro);
  _ss('skon_microquestion', '1');
  _adjustMicroPosition(micro);
  window.addEventListener('scroll',
    _debounce(function() { _adjustMicroPosition(micro); }, 200),
    { passive: true }
  );
}

function _adjustMicroPosition(micro) {
  if (!micro) micro = document.getElementById('skon-nc-micro');
  if (!micro) return;
  const atc = document.getElementById('sticky-add-to-cart-bar');
  micro.style.bottom = (atc && atc.offsetHeight > 0)
    ? (atc.offsetHeight + 12) + 'px'
    : '20px';
}

/* Step 1 — domanda iniziale */
function _buildStep1(micro) {
micro.innerHTML =
  '<p class="skon-nc-micro-q">'
  + 'Hai mai acquistato prodotti Skön?'
  + '<button class="skon-nc-micro-close" onclick="window._skonCloseMicro()" aria-label="Chiudi">'
  + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
  + '</button>'
  + '</p>'
  + '<div class="skon-nc-micro-btns">'
  + '<button class="skon-nc-micro-btn skon-nc-micro-btn--secondary"'
  + ' onclick="window._skonDeclare(\'returning\')">Sì, sono già cliente</button>'
  + '<button class="skon-nc-micro-btn"'
  + ' onclick="window._skonDeclare(\'new\')">Non ancora</button>'
  + '<button class="skon-nc-micro-back" onclick="window._skonCloseMicro()">Chiudi</button>'
  + '</div>';
}

/* Step 2 NC — invito al quiz */
function _buildStep2NC(micro) {
  const name = _ss('skon_rc_name') || '';
  const firstName = name.split(' ')[0] || '';
  const q = firstName
    ? 'Ciao ' + firstName + ',<br>conosci già la routine ideale per te?'
    : 'Conosci la routine ideale per te?';

  micro.innerHTML =
    '<p class="skon-nc-micro-q">' + q
    + '<button class="skon-nc-micro-close" onclick="window._skonCloseMicro()" aria-label="Chiudi">'
    + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
    + '</button></p>'
    + '<p class="skon-nc-micro-sub">Bastano 2 minuti per scoprire quali prodotti Skön sono perfetti per la tua pelle. (E c\'è qualcosa per te alla fine!🎁)</p>'
    + '<div class="skon-nc-micro-btns">'
    + '<a href="' + QUIZ_URL + '" class="skon-nc-micro-btn skon-nc-micro-btn--link">Fai il test gratuito →</a>'
    + '</div>';
}

/* Step 2 RC — form email */
function _buildStep2RC(micro) {
  micro.innerHTML =
  '<p class="skon-nc-micro-q">Bentornata in Skön! 🩷'
  + '<button class="skon-nc-micro-close" onclick="window._skonCloseMicro()" aria-label="Chiudi">'
  + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
  + '</button></p>'
  + '<p class="skon-nc-micro-sub">Inserisci l\'email con cui hai acquistato — ti riserviamo qualcosa di speciale.</p>'
  + '<div class="skon-nc-micro-form">'
  + '<input type="email" id="skon-rc-email" class="skon-nc-micro-input" placeholder="La tua email" oninput="window._skonPrefillName(this.value)">'
  + '<input type="text" id="skon-rc-name" class="skon-nc-micro-input" placeholder="Il tuo nome (facoltativo)">'
  + '<button class="skon-nc-micro-btn" id="skon-rc-submit" onclick="window._skonSubmitRC()">Continua →</button>'
  + '</div>'
  + '</div>';
}

/* Step 3 RC-A — quiz con email pre-compilata */
function _buildStep3RCA(micro, firstName) {
  const greeting = firstName ? firstName + ', abbiamo' : 'Abbiamo';
  micro.innerHTML =
  '<p class="skon-nc-micro-q">' + greeting + ' trovato il tuo profilo.'
  + '<button class="skon-nc-micro-close" onclick="window._skonCloseMicro()" aria-label="Chiudi">'
  + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
  + '</button></p>'
  + '<p class="skon-nc-micro-sub">Non hai ancora scoperto la tua routine ideale Skön. Bastano 2 minuti — e con il tuo codice riservato paghi di meno.</p>'
  + '<div class="skon-nc-micro-btns">'
  + '<a href="' + QUIZ_URL + '" class="skon-nc-micro-btn skon-nc-micro-btn--link">Scopri la tua routine →</a>'
  + '<button class="skon-nc-micro-back" onclick="window._skonCloseMicro()">Chiudi</button>'
  + '</div>';
}

/* Step 3 RC-B — mostra il codice assegnato (dinamico) */
function _buildStep3RCB(micro, firstName, assignedCode) {
  const greeting = firstName ? firstName + ', il' : 'Il';
  const code = _escapeHtml((assignedCode || '').trim());
  micro.innerHTML =
  '<p class="skon-nc-micro-q">' + greeting + ' tuo codice è pronto.'
  + '<button class="skon-nc-micro-close" onclick="window._skonCloseMicro()" aria-label="Chiudi">'
  + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
  + '</button></p>'
  + '<p class="skon-nc-micro-sub">Usa <strong>' + code + '</strong> al checkout: un EXTRA di benvenuto sui prodotti singoli, che si somma alle promozioni già attive. Puoi usarlo una sola volta.</p>'
  + '<div class="skon-nc-micro-btns">'
  + '<a href="/collections/all" class="skon-nc-micro-btn skon-nc-micro-btn--link">Vai allo shop →</a>'
  + '<button class="skon-nc-micro-back" onclick="window._skonCloseMicro()">Chiudi</button>'
  + '</div>';
}

/* Step 3 RC-C — ringraziamento */
function _buildStep3RCC(micro, firstName) {
  const greeting = firstName ? firstName + ', g' : 'G';
  micro.innerHTML =
  '<p class="skon-nc-micro-q">' + greeting + 'razie per la fiducia in Skön.'
  + '<button class="skon-nc-micro-close" onclick="window._skonCloseMicro()" aria-label="Chiudi">'
  + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
  + '</button></p>'
  + '<p class="skon-nc-micro-sub">Siamo sempre a disposizione per qualsiasi consiglio o necessità.</p>'
  + '<div class="skon-nc-micro-btns">'
  + '<a href="' + _supportHref() + '" target="_blank" rel="noopener" class="skon-nc-micro-btn skon-nc-micro-btn--secondary">Contattaci</a>'
  + '<button class="skon-nc-micro-back" onclick="window._skonCloseMicro()">Chiudi</button>'
  + '</div>';
}

/* Step loading */
function _buildStepLoading(micro) {
  micro.innerHTML =
  '<p class="skon-nc-micro-q">Un momento…'
  + '<button class="skon-nc-micro-close" onclick="window._skonCloseMicro()" aria-label="Chiudi">'
  + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
  + '</button></p>'
  + '<div class="skon-nc-micro-loading">'
  + '<div class="skon-nc-micro-spinner"></div>'
  + '<button class="skon-nc-micro-back" onclick="window._skonCloseMicro()">Chiudi</button>'
  + '</div>';
}

/* ── Azioni globali micro-domanda ────────────────────────────────────── */
window._skonCloseMicro = function() {
  const micro = document.getElementById('skon-nc-micro');
  if (!micro) return;
  micro.classList.add('skon-nc-micro--answered');
  setTimeout(function() { micro.remove(); }, 300);
};

window._skonDeclare = function(type) {
  _ss('skon_nc_declared', type);
  _ss('skon_visitor_type', type === 'new' ? 'NC' : 'RC');

  const micro = document.getElementById('skon-nc-micro');
  if (!micro) return;

  if (type === 'new') {
    // NC confermato — mostra step 2 NC
    _buildStep2NC(micro);
    // Spegne strip se era RC
  } else {
    // RC dichiarato — mostra form email
    _buildStep2RC(micro);
    // Spegne strip NC
    window._skonCloseStrip();
    document.querySelectorAll('.skon-nc-price-note').forEach(function(el) { el.remove(); });
  }
};

window._skonPrefillName = (function() {
  let lastEmail = '';
  let timer = null;

  return async function(val) {
    const email = val.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    if (email === lastEmail) return;

    clearTimeout(timer);
    timer = setTimeout(async function() {
      lastEmail = email;
      const nameEl = document.getElementById('skon-rc-name');
      if (!nameEl || nameEl.value.trim()) return;

      const data = await _checkCustomer(email);
      if (data && data.firstName) {
        nameEl.value = data.firstName;
        nameEl.style.transition = 'border-color .3s';
        nameEl.style.borderColor = '#1F5842';
        setTimeout(function() { nameEl.style.borderColor = ''; }, 2000);
      }
    }, 400); // 400ms debounce — evita chiamate a ogni carattere
  };
})();

window._skonSubmitRC = async function() {
  const emailEl = document.getElementById('skon-rc-email');
  const nameEl  = document.getElementById('skon-rc-name');
  const errorEl = document.getElementById('skon-rc-error');
  const micro   = document.getElementById('skon-nc-micro');

  if (!emailEl || !micro) return;

  const email = emailEl.value.trim().toLowerCase();
  const name  = nameEl ? nameEl.value.trim() : '';

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    if (errorEl) errorEl.style.display = 'block';
    return;
  }
  if (errorEl) errorEl.style.display = 'none';

  // Salva email e nome in sessionStorage per pre-compilare il quiz
  _ss('skon_rc_email', email);
  if (name) _ss('skon_rc_name', name);

  // Loading
  _buildStepLoading(micro);

  // Chiama Worker
  const data = await _checkCustomer(email);

  if (!data || !data.isCustomer) {
    /* v2.6.0 — Non trovato negli ordini Shopify: NC ACCERTATO, non "presunto".
       Persistiamo la certificazione (SkonID.markNonCustomer) invece di
       scriverla solo in sessione. `!data` (rete/timeout) NON è una
       certificazione: lì non si scrive nulla. */
    if (data && window.SkonID && typeof window.SkonID.markNonCustomer === 'function') {
      window.SkonID.markNonCustomer();
    } else {
      _ss('skon_visitor_type', 'NC');
    }
    _buildStep2NC(micro);
    return;
  }

  // È un cliente — determina il caso
  const firstName = data.firstName || name.split(' ')[0] || '';
  /* v2.6.0 — la regola vive in SkonID: qui non si scrivono cookie a mano.
     markCustomer() imposta anche skon_rc_verified in sessione. */
  if (window.SkonID && typeof window.SkonID.markCustomer === 'function') {
    window.SkonID.markCustomer();
  } else {
    _ss('skon_rc_verified', '1');   // rete: SkonID non caricato
  }

  // Codice sconto assegnato a questo contatto (dinamico, da Magnews
  // QUIZ_DISCOUNT_ASSIGNED). E' il codice comunicato al visitatore il
  // giorno del quiz: e' quello che mostriamo e applichiamo, mai un hardcoded.
  const assignedCode = (data.discountAssigned || '').trim();

  if (!data.quizCompleted) {
    // Caso A — quiz non compilato
    _buildStep3RCA(micro, firstName);
  } else if (!data.rcDiscountUsed && assignedCode) {
    // Caso B — quiz compilato, codice assegnato NON ancora usato (verificato
    // sugli ordini Shopify dal Worker Magnews v2.7.0). Lo mostriamo e applichiamo.
    _buildStep3RCB(micro, firstName, assignedCode);
    // Applica il codice assegnato silenziosamente
    try {
      fetch('/discount/' + encodeURIComponent(assignedCode), { credentials: 'include' });
      sessionStorage.setItem('skon_discount', assignedCode);
    } catch(e) {}
  } else {
    // Caso C — quiz compilato e codice gia' usato (o nessun codice assegnato).
    _buildStep3RCC(micro, firstName);
  }
};

/* ── Sticky bar (navigazione post-PDP) ──────────────────────────────── */
async function _resolveIsCustomer() {
  // Caso 1 — RC già verificato dal Worker in questa sessione
  if (_ss('skon_rc_verified') === '1') return true;

  // Caso 2 — email in sessionStorage → chiama Worker
  const email = _ss('skon_rc_email');
  if (email) {
    const data = await _checkCustomer(email);
    if (data && data.isCustomer) {
      if (window.SkonID && typeof window.SkonID.markCustomer === 'function') {
        window.SkonID.markCustomer();
      } else {
        _ss('skon_rc_verified', '1');
      }
      return true;
    }
  }

  // Caso 3 — loggato su Shopify ma senza email disponibile → trattiamo come cliente
  if (_getCookie('_shopify_customer_token')) return true;

  return false;
}
async function _renderStickyBar() {
  console.log('[skon] _renderStickyBar start');
  if (_ss('skon_strip_closed') === '1') { console.log('[skon] blocked: strip_closed'); return; }
  if (document.getElementById('skon-nc-sticky')) { console.log('[skon] blocked: already exists'); return; }

  const result = _quizResult();
  const name   = _userName();
  console.log('[skon] result:', result ? 'present' : 'null', '| name:', name);

  let state, text, ctaLabel, ctaHref;

  if (!result) {
    state    = 'discover';
    text     = name
  ? name + ', è la prima volta su Skön?'
  : 'Prima volta su Skön?';
ctaLabel = 'Scopri la routine ideale per te →';
ctaHref  = QUIZ_URL;
    console.log('[skon] state: discover');

  } else {
    const isCustomer = await _resolveIsCustomer();
    console.log('[skon] isCustomer:', isCustomer);

    if (isCustomer) {
      state    = 'loyalty';
      text     = name
        ? name + ', grazie per la fiducia in Skön.'
        : 'Grazie per la fiducia in Skön.';
      ctaLabel = 'Lascia una recensione →';
      ctaHref  = '#';
    } else {
      const pct      = result.pct || _getDiscountPct();
      const pctLabel = Math.round(pct * 100) + '%';
      state    = 'activate';
      text     = name
        ? name + ', hai ancora il tuo -' + pctLabel + ' attivo.'
        : 'Hai ancora il tuo -' + pctLabel + ' attivo.';
      ctaLabel = 'Usalo ora →';
      ctaHref  = '/collections/catalogo';
    }
    console.log('[skon] state:', state);
  }

  console.log('[skon] creating sticky element');
  const sticky = document.createElement('div');
  sticky.id        = 'skon-nc-sticky';
  sticky.className = 'skon-nc-sticky skon-nc-sticky--' + state;
  sticky.innerHTML =
    '<div class="skon-nc-sticky-inner">'
    + '<span class="skon-nc-sticky-text">' + text + '</span>'
    + '<a href="' + ctaHref + '" class="skon-nc-sticky-cta">' + ctaLabel + '</a>'
    + '<button class="skon-nc-sticky-close" aria-label="Chiudi"'
    + ' onclick="document.getElementById(\'skon-nc-sticky\').remove();'
    + 'var m=document.getElementById(\'MainContent\');if(m)m.style.paddingTop=\'\';'
    + 'window._ss(\'skon_strip_closed\',\'1\');">'
    + '<svg width="10" height="10" viewBox="0 0 24 24" fill="none"'
    + ' stroke="currentColor" stroke-width="2.5" stroke-linecap="round">'
    + '<line x1="18" y1="6" x2="6" y2="18"/>'
    + '<line x1="6" y1="6" x2="18" y2="18"/></svg>'
    + '</button>'
    + '</div>';

  document.body.appendChild(sticky);
  console.log('[skon] sticky appended');

function _adjustStickyTop() {
  const announcements = document.getElementById(
    'shopify-section-sections--25042149376375__header_announcements_kcHY6p'
  );
  const headerComponent = document.querySelector('header-component');
  
  if (window.scrollY > 0 && announcements) {
    // Scrollato — barra promo nascosta, usa solo header component
    sticky.style.top = (headerComponent ? headerComponent.offsetHeight : 60) - 2 + 'px';
  } else {
    // In cima — include barra promo + header
    const annH    = announcements ? announcements.offsetHeight : 0;
    const headerH = headerComponent ? headerComponent.offsetHeight : 60;
    sticky.style.top = (annH + headerH) + 'px';
  }
}

function _adjustBodyPadding() {
  const main = document.getElementById('MainContent');
  if (main) main.style.paddingTop = sticky.offsetHeight + 'px';
}
_adjustBodyPadding();
window.addEventListener('scroll', _debounce(_adjustBodyPadding, 200), { passive: true });
window.addEventListener('resize', _debounce(_adjustBodyPadding, 200), { passive: true });
  window.addEventListener('scroll', _debounce(_adjustStickyTop, 200), { passive: true });
  window.addEventListener('resize', _debounce(_adjustStickyTop, 200), { passive: true });
}

window._ss = _ss;

/* ── Badge protocollo (collection) con IntersectionObserver ──────────── */
function _renderProtocolBadges() {
  const result = _quizResult();
  if (!result || !result.protocol) return;

  const PROTOCOL_HANDLE_MAP = window.SKON_HANDLE_MAP || {};

  const CARD_SELECTOR = 'product-card, [data-product-handle], .product-card, .grid__item[class*="product"], [class*="product-item"], .collection-grid__item';

  function _getHandle(card) {
    return card.dataset.productHandle || (function() {
      const a = card.querySelector('a[href*="/products/"]');
      return a ? a.getAttribute('href').split('/products/')[1].split('?')[0] : null;
    })();
  }

  function _applyBadge(card) {
    if (card.querySelector('.skon-nc-protocol-badge')) return;
    const handle = _getHandle(card);
    if (!handle) return;
    const isInProtocol = result.protocol.some(function(id) {
      const fragment = PROTOCOL_HANDLE_MAP[id];
      return fragment && handle.includes(fragment);
    });
    if (!isInProtocol) return;
    const badge = document.createElement('div');
    badge.className   = 'skon-nc-protocol-badge';
    badge.textContent = 'Nel tuo protocollo';
    card.style.position = 'relative';
    card.appendChild(badge);
  }

  // Processa tutte le card già nel DOM
  function _processAll() {
    document.querySelectorAll(CARD_SELECTOR).forEach(_applyBadge);
  }

  // Prima passata immediata
  _processAll();

  // Seconda passata dopo 500ms — per card già visibili ma non ancora nel DOM al load
  setTimeout(_processAll, 500);

  // MutationObserver — per card aggiunte dal lazy load del tema
  const mutationObs = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        // La card stessa
        if (node.matches && node.matches(CARD_SELECTOR)) {
          _applyBadge(node);
        }
        // Card annidate nel nodo aggiunto
        node.querySelectorAll && node.querySelectorAll(CARD_SELECTOR).forEach(_applyBadge);
      });
    });
  });

  mutationObs.observe(document.body, { childList: true, subtree: true });

  // Smette di osservare dopo 30s per non appesantire
  setTimeout(function() { mutationObs.disconnect(); }, 30000);
}


/* ── Exit intent (mobile) ────────────────────────────────────────────── */
function _installExitIntent() {
  if (_ss('skon_exit_shown') === '1') return;

  var inactivityTimer = null;
  var maxScrollY      = 0;
  var triggered       = false;

  function trigger(type) {
    if (triggered) return;
    triggered = true;
    clearTimeout(inactivityTimer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('click', onActivity);
    _showExitSheet(type);
  }

  function resetTimer() {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(function() { trigger('inactivity'); }, 30000);  // 12 lug: 25s→30s, coordinato col popup identità fs-onboarding a 20s
  }

  function onActivity() { resetTimer(); }

  var onScroll = _debounce(function() {
    var currentY = window.scrollY;
    if (currentY > maxScrollY) maxScrollY = currentY;
    var pageH  = document.documentElement.scrollHeight - window.innerHeight;
    var pct    = pageH > 0 ? currentY / pageH : 0;
    var maxPct = pageH > 0 ? maxScrollY / pageH : 0;
    if (maxPct >= 0.5 && pct <= 0.15) {
      trigger('scrollback');
      return;
    }
    resetTimer();
  }, 150);

  resetTimer();
  window.addEventListener('scroll',  onScroll,   { passive: true });
  document.addEventListener('click', onActivity, { passive: true });
}

function _showExitSheet(type) {
  if (window.SkonQuizExcluded && window.SkonQuizExcluded()) return;  // v2.9.2 — PDP esclusa dalle CTA quiz (SKON_NO_QUIZ_PRODUCTS in skon-handle-map.js)
  if (_quizResult()) return;  // v2.9.0 — l'exit-intent invita al quiz: mai a chi l'ha già fatto
  if (_ss('skon_exit_shown') === '1') return;
  if (_ss('skon_added_to_cart') === '1') return;
  _ss('skon_exit_shown', '1');

  const name = _userName();

  var headline, sub, primaryCta, secondaryCta, secondaryHref;

  // ── Copy v2.8.0 (12 lug) — NESSUNA percentuale esplicita nel modale.
  // Framing: "un vantaggio / extra di benvenuto che si somma alle promozioni
  // già attive". Evita la 'zuppa di percentuali' in pagina e toglie ogni
  // dipendenza da _getDiscountPct()/nc-config qui (niente più rischio di
  // mostrare un fallback 25% se /nc-config è lento o giù).
  // _showExitSheet è chiamato solo da _runPdp() per NC (riga _runPdp:
  // 'if (_classify() === "RC") return;'), quindi resta esperienza NC-only.
  if (type === 'scrollback') {
    headline     = 'Aspetta — un vantaggio in più per te.';
    sub          = (name ? name + ', in' : 'In')
      + ' 2 minuti scopri la routine pensata per la tua pelle —'
      + ' e sblocchi uno sconto di benvenuto che si somma alle promozioni di oggi.';
    primaryCta   = 'Fai il test e sblocca il tuo extra \u2192';
    secondaryCta = 'Torna al prodotto';
    secondaryHref = null;
  } else {
    headline     = 'Hai dubbi? Con il test spendi ancora meno.';
    sub          = (name ? name + ', in' : 'In')
      + ' 2 minuti il test ti dice se questo prodotto è pensato per la tua pelle'
      + ' — e sblocchi un extra di benvenuto oltre alle promozioni attive. Oppure chiedi a noi.';
    primaryCta   = 'Fai il test e sblocca il tuo extra \u2192';
    secondaryCta = 'Parla con noi';
    secondaryHref = _supportHref();
  }

  const sheet = document.createElement('div');
  sheet.id        = 'skon-nc-exit';
  sheet.className = 'skon-nc-exit';

  const secondaryBtn = secondaryHref
    ? '<a href="' + secondaryHref + '" target="_blank" rel="noopener"'
      + ' class="skon-nc-exit-btn-secondary">' + secondaryCta + '</a>'
    : '<button class="skon-nc-exit-btn-secondary"'
      + ' onclick="window._skonCloseExit()">' + secondaryCta + '</button>';

  sheet.innerHTML =
    '<div class="skon-nc-exit-sheet">'
    + '<div class="skon-nc-exit-handle"><div class="skon-nc-exit-pill"></div></div>'
    + '<div class="skon-sheet-inner">'
    + '<button class="skon-nc-exit-close" onclick="window._skonCloseExit()" aria-label="Chiudi">'
    + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="2.5" stroke-linecap="round">'
    + '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
    + '</button>'
    + '<p class="skon-nc-exit-headline">' + headline + '</p>'
    + '<p class="skon-nc-exit-sub">' + sub + '</p>'
    + '<div class="skon-nc-exit-btns">'
    + '<a href="' + QUIZ_URL + '" class="skon-nc-exit-btn-primary">' + primaryCta + '</a>'
    + secondaryBtn
    + '</div>'
    + '</div>'
    + '</div>';

  sheet.addEventListener('click', function(e) {
    if (e.target === sheet) window._skonCloseExit();
  });

  document.body.appendChild(sheet);
  _installSwipeToClose(sheet.querySelector('.skon-nc-exit-sheet'));
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      sheet.classList.add('skon-nc-exit--visible');
    });
  });
}

function _installSwipeToClose(sheet) {
  const handle = sheet.querySelector('.skon-nc-exit-handle');
  const pill   = sheet.querySelector('.skon-nc-exit-pill');
  const inner  = sheet.querySelector('.skon-sheet-inner');
  if (!handle) return;

  var EASE       = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var EASE_BACK  = 'cubic-bezier(0.34, 1.56, 0.64, 1)';
  var BAND_CLOSE = 30, DAMP_CLOSE = 0.3;
  var BAND_OPEN  = 50, DAMP_OPEN  = 0.18;
  var THRESHOLD  = 80, SCALE_DAMP = 0.00015;
  var startY = 0, currentY = 0;

  function _translateY(raw) {
    if (raw > 0) {
      return raw <= BAND_CLOSE ? raw * DAMP_CLOSE : (BAND_CLOSE * DAMP_CLOSE) + (raw - BAND_CLOSE);
    } else {
      var a = Math.abs(raw);
      return -(a <= BAND_OPEN ? a * DAMP_OPEN : (BAND_OPEN * DAMP_OPEN) + (a - BAND_OPEN) * (DAMP_OPEN * 0.4));
    }
  }
  function _scaleY(raw) { return Math.max(0.92, Math.min(1.04, 1 - raw * SCALE_DAMP)); }

  function _pillGrab() {
    if (!pill) return;
    pill.style.transition   = 'transform 120ms cubic-bezier(0.34,1.56,0.64,1), background 120ms';
    pill.style.transform    = 'scaleX(1.4) scaleY(0.55)';
    pill.style.background   = 'rgba(31,88,66,.6)';
    handle.style.transition = 'background 120ms cubic-bezier(0.34,1.56,0.64,1)';
    handle.style.background = 'rgba(31,88,66,.10)';
  }
  function _pillRelease() {
    if (!pill) return;
    pill.style.transition   = 'transform 200ms ' + EASE + ', background 200ms ' + EASE;
    pill.style.transform    = 'none';
    pill.style.background   = '';
    handle.style.transition = 'background 300ms ' + EASE;
    handle.style.background = '';
  }

  function _runGestureTutorial() {
    if (sessionStorage.getItem('skon_sheet_tutorial_done')) return;
    sessionStorage.setItem('skon_sheet_tutorial_done', '1');
    var hint = document.createElement('div');
    hint.style.cssText = 'position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:18px;pointer-events:none;opacity:0;will-change:transform,opacity;';
    hint.textContent = '☝️';
    handle.appendChild(hint);
    var ET = EASE;
    function _s(d, dur, tr, op) {
      setTimeout(function() {
        hint.style.transition = 'transform ' + dur + 'ms ' + ET + ', opacity ' + dur + 'ms ease';
        hint.style.transform  = tr;
        hint.style.opacity    = String(op);
      }, d);
    }
    function _on(d) { setTimeout(function() {
      if (!pill) return;
      pill.style.transition = 'transform 150ms cubic-bezier(0.34,1.56,0.64,1), background 150ms';
      pill.style.transform = 'scaleX(1.3) scaleY(0.6)'; pill.style.background = 'rgba(31,88,66,.6)';
      handle.style.transition = 'background 150ms cubic-bezier(0.34,1.56,0.64,1)';
      handle.style.background = 'rgba(31,88,66,.10)';
    }, d); }
    function _off(d) { setTimeout(function() {
      if (!pill) return;
      pill.style.transition = 'transform 300ms ' + ET + ', background 300ms ' + ET;
      pill.style.transform = 'none'; pill.style.background = '';
      handle.style.transition = 'background 300ms ' + ET; handle.style.background = '';
    }, d); }
    _s(0, 200, 'translate(-50%,-50%)', 0);
    _s(50, 250, 'translate(-50%,-50%)', 1);
    _on(400);  _s(400, 400, 'translate(-50%,calc(-50% + 14px))', 1); _off(820);  _s(850, 350, 'translate(-50%,-50%)', 1);
    _on(1300); _s(1300, 400, 'translate(-50%,calc(-50% + 14px))', 1); _off(1720); _s(1750, 350, 'translate(-50%,-50%)', 1);
    _s(2200, 300, 'translate(-50%,-50%)', 0);
    setTimeout(function() {
      hint.remove();
      handle.style.background = ''; if (pill) { pill.style.background = ''; pill.style.transform = 'none'; }
    }, 2600);
  }

  handle.addEventListener('touchstart', function(e) {
    startY = currentY = e.touches[0].clientY;
    sheet.style.transition      = 'none';
    sheet.style.transformOrigin = 'center bottom';
    sheet.style.overflow        = 'hidden';
    _pillGrab();
  }, { passive: true });

  handle.addEventListener('touchmove', function(e) {
    currentY = e.touches[0].clientY;
    var raw = currentY - startY;
    var progress = Math.min(1, Math.max(0, raw / 120));
    sheet.style.transform = 'translateY(' + _translateY(raw) + 'px)';
    sheet.style.opacity   = String(Math.max(0.15, 1 - progress * 1.5));
  }, { passive: true });

  handle.addEventListener('touchend', function() {
    _pillRelease();
    sheet.style.transformOrigin = '';
    sheet.style.overflow        = '';
    var raw = currentY - startY;
    sheet.style.opacity = '1';
    if (raw > THRESHOLD) {
      window._skonCloseExit();
    } else {
      sheet.style.transition = 'transform 450ms ' + EASE_BACK + ', opacity 300ms ' + EASE;
      sheet.style.transform  = 'none';
    }
  }, { passive: true });

  /* Tutorial — 10s dopo apertura */
  setTimeout(_runGestureTutorial, 10000);
}

window._skonCloseExit = function() {
  const sheet = document.getElementById('skon-nc-exit');
  if (!sheet) return;
  sheet.classList.remove('skon-nc-exit--visible');
  setTimeout(function() {
    sheet.remove();
    document.body.style.overflow = '';
  }, 280);
};

/* ── Watch aggiunta al carrello ──────────────────────────────────────── */
function _watchCartAdd() {
  document.addEventListener('click', function(e) {
    const btn = e.target.closest(
      '[name="add"], .btn-add-to-cart, [data-add-to-cart], form[action="/cart/add"] [type="submit"]'
    );
    if (btn) _ss('skon_added_to_cart', '1');
  }, { passive: true });
}

/* ── Micro-domanda schedulata ────────────────────────────────────────── */
function _scheduleMicroQuestion() {
  let fired = false;
  function fire() {
    if (fired) return;
    fired = true;
    _renderMicroQuestion();
  }

  setTimeout(fire, 20000);

  const onScroll = _debounce(function() {
    const scrolled = window.scrollY + window.innerHeight;
    const total    = document.documentElement.scrollHeight;
    if (scrolled / total >= 0.6) {
      window.removeEventListener('scroll', onScroll);
      fire();
    }
  }, 150);

  window.addEventListener('scroll', onScroll, { passive: true });
}

/* ══════════════════════════════════════════════════════════════════════
   ENTRY POINTS
══════════════════════════════════════════════════════════════════════ */

function _isPdp()        { return window.location.pathname.includes('/products/'); }
function _isCollection() { return window.location.pathname.includes('/collections/'); }
function _currentProductHandle() {
  const parts = window.location.pathname.split('/products/');
  return parts.length > 1 ? parts[1].split('/')[0].split('?')[0] : null;
}

function _runPdp() {
  /* v2.6.0 — Era `if (_classify() !== 'NC') return;`, cioè: esce anche su
     'unknown'. Ma 'unknown' è lo stato del traffico ORGANICO: getVisitorType()
     produce 'NC' solo con ?audience=new, autodichiarazione o modello. Di fatto
     la NC Experience era riservata al traffico Meta, senza che fosse scritto
     da nessuna parte.
     Decisione (Matteo, 10 lug 2026): un 'unknown' si tratta come NC. Chi ha
     comprato lo sappiamo — cookie skon_customer, token Shopify, conferma
     Worker. Tutto il resto è, fino a prova contraria, un nuovo cliente.
     Qui esce SOLO chi è accertatamente RC. */
  if (_classify() === 'RC') return;

  /* v2.6.0 — Fino al 9 lug 2026 chi aveva fatto il quiz era classificato RC e
     usciva qui sopra: la NC Experience si spegneva per 60 giorni, e il ramo
     _renderPriceNote() non è MAI stato eseguito in produzione.
     Ora un lead post-quiz è correttamente NC e arriverebbe fin qui. Prima di
     accendere del codice mai girato, lo teniamo dietro un flag esplicito.
     `SKON_NC_POSTQUIZ = false` → comportamento identico a oggi.
     `true` → il lead vede la nota col SUO codice e il SUO prezzo.
     Il livePrice (skon-pdp-live-price.js) non passa da qui: lo vedono già
     tutti, RC compresi. */
  const result = _quizResult();

  /* v2.7.0 — Il cancello guarda la ROUTINE, non il cookie del quiz.
     Il cookie dura 60 giorni; il localStorage può essere stato svuotato, o si
     può arrivare da un altro dispositivo. Chi ha il cookie ma non la routine
     non ha nulla da mostrare: va trattato come un visitatore nuovo, e invitato
     al quiz. Basarsi sul cookie l'avrebbe lasciato senza strip E senza nota. */
  const hasRoutine = !!result;
  if (hasRoutine && !window.SKON_NC_POSTQUIZ) return;

  /* La strip INVITA a fare il quiz: non si mostra a chi ha già una routine. */
  if (!hasRoutine) _renderStrip(_getProductId());

  if (hasRoutine) {
    if (result.code) {
      /* Ha un codice personale: lo riapplichiamo e lasciamo parlare lo stack
         prezzi (skon-pdp-live-price.js), che chiede a Shopify quanto alloca
         davvero su questa variante. Nessuna nota: sarebbe un secondo racconto
         dello stesso prezzo, e per giunta non verificato. */
      _ensureDiscountApplied(result.code);
    } else {
      /* Routine senza codice (risultato legacy): la nota è l'unica cosa che
         abbiamo. Resta subordinata allo stack. */
      _renderPriceNote(_currentProductHandle());
    }
  } else {
    _renderPriceNoteGeneric();
  }

  // MICRO-QUESTION SOSPESA (24 mag 2026): la domanda "sei nuovo o di ritorno?"
  // ora vive UNICAMENTE in skon-fs-onboarding.js (versione più recente, già
  // live). Tenere entrambe creava un doppione: due toast con la stessa domanda
  // che scrivono sulle stesse chiavi (skon_nc_declared, skon_visitor_type).
  // La risposta di fs-onboarding viene comunque letta da SkonID, quindi
  // nc-experience la riceve tramite la classificazione condivisa.
  // Per riattivarla qui (e disattivarla in fs-onboarding) scommentare:
  // _scheduleMicroQuestion();
  _renderQuizLinkAfterATC();   // v2.3.0 — item 1c Fase 1 UX pre-launch
  _installExitIntent();
  _watchCartAdd();
}

function _runCollection() {
  const hasWidget = !!document.getElementById('skon-protocol-widget');
  const hasQuizResult = !!_quizResult();

  /* v2.6.0 — come _runPdp: esce solo chi è accertatamente RC. 'unknown' è il
     traffico organico e si tratta come NC. Lasciare qui `!== 'NC'` avrebbe
     creato due regole diverse nello stesso file, per la stessa domanda. */
  if (_classify() === 'RC') {
    if (!(hasWidget && hasQuizResult)) _renderStickyBar();
    return;
  }
  _renderProtocolBadges();
  if (!(hasWidget && hasQuizResult)) _renderStickyBar();
}

function _runGeneric() {
  if (_classify() === 'RC') return;   // v2.6.0 — vedi _runPdp
  if (_quizResult()) _renderStickyBar();
}

async function init() {
  if (!_isDebugAllowed()) return;

  // Su /pages/ spegni tutto e blocca per l'intera sessione
  if (window.location.pathname.startsWith('/pages/')) {
    _ss('skon_visitor_type', 'unknown');
    return;
  }

  // v2.4.0 — la percentuale del master PRIMA di disegnare qualunque cosa che
  // la contenga (strip, exit-intent, prezzi simulati). Meglio una strip che
  // compare 200ms dopo, che una strip che dice -25% e poi salta a -30% davanti
  // agli occhi dell'utente. Se il Worker non risponde, _getDiscountPct()
  // ripiega sulla config A/B congelata: nessun blocco, nessuna attesa infinita.
  // Chi ha gia' fatto il quiz NON e' influenzato: la sua pct viene dal suo
  // codice personale (skon_quiz_result.pct), che ha priorita' sul master.
  await _loadMasterPct();

  // Pre-compila email/nome nel quiz se arriva da flusso RC
  const rcEmail = _ss('skon_rc_email');
  const rcName  = _ss('skon_rc_name');
  if      (_isPdp())        _runPdp();
  else if (_isCollection()) _runCollection();
  else                      _runGeneric();
}

window.addEventListener('load', function() { init(); }, { once: true });

})();